var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 2.85693H1.71428C0.767511 2.85693 0 3.62444 0 4.57122V14.2855C0 15.2323 0.767511 15.9998 1.71428 15.9998H11.4286C12.3753 15.9998 13.1428 15.2323 13.1428 14.2855V4.57122C13.1428 3.62444 12.3753 2.85693 11.4286 2.85693Z",
    fill: "#E52333",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2861 1.10693e-09H4.00042C3.05877 -3.3481e-05 2.29336 0.759508 2.28613 1.70113C2.28613 1.70571 2.28613 1.7097 2.28613 1.71428H11.429C13.0062 1.71616 14.2842 2.99424 14.2861 4.57141V13.7143C14.2907 13.7143 14.2947 13.7143 14.2993 13.7143C15.2409 13.707 16.0004 12.9416 16.0004 12V1.71428C16.0004 0.767511 15.2329 1.10693e-09 14.2861 1.10693e-09Z",
    fill: "#E52333",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/Duplicate.91eca60f41ad93d90eba68c0fcc1dcee.svg";
export { ForwardRef as ReactComponent };